/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarificationTotauxDto } from './TarificationTotauxDto';
import {
    TarificationTotauxDtoFromJSON,
    TarificationTotauxDtoFromJSONTyped,
    TarificationTotauxDtoToJSON,
    TarificationTotauxDtoToJSONTyped,
} from './TarificationTotauxDto';
import type { BienTarifDto } from './BienTarifDto';
import {
    BienTarifDtoFromJSON,
    BienTarifDtoFromJSONTyped,
    BienTarifDtoToJSON,
    BienTarifDtoToJSONTyped,
} from './BienTarifDto';
import type { GarantieTarifDto } from './GarantieTarifDto';
import {
    GarantieTarifDtoFromJSON,
    GarantieTarifDtoFromJSONTyped,
    GarantieTarifDtoToJSON,
    GarantieTarifDtoToJSONTyped,
} from './GarantieTarifDto';
import type { FraisTarifDto } from './FraisTarifDto';
import {
    FraisTarifDtoFromJSON,
    FraisTarifDtoFromJSONTyped,
    FraisTarifDtoToJSON,
    FraisTarifDtoToJSONTyped,
} from './FraisTarifDto';

/**
 * Détail complet de tarification d'un tunnel.
 * @export
 * @interface TarificationDetailsDto
 */
export interface TarificationDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof TarificationDetailsDto
     */
    objectId?: string;
    /**
     * 
     * @type {number}
     * @memberof TarificationDetailsDto
     */
    objectType?: number;
    /**
     * 
     * @type {TarificationTotauxDto}
     * @memberof TarificationDetailsDto
     */
    totaux?: TarificationTotauxDto;
    /**
     * 
     * @type {Array<GarantieTarifDto>}
     * @memberof TarificationDetailsDto
     */
    garanties?: Array<GarantieTarifDto> | null;
    /**
     * 
     * @type {Array<FraisTarifDto>}
     * @memberof TarificationDetailsDto
     */
    frais?: Array<FraisTarifDto> | null;
    /**
     * 
     * @type {Array<BienTarifDto>}
     * @memberof TarificationDetailsDto
     */
    biens?: Array<BienTarifDto> | null;
}

/**
 * Check if a given object implements the TarificationDetailsDto interface.
 */
export function instanceOfTarificationDetailsDto(value: object): value is TarificationDetailsDto {
    return true;
}

export function TarificationDetailsDtoFromJSON(json: any): TarificationDetailsDto {
    return TarificationDetailsDtoFromJSONTyped(json, false);
}

export function TarificationDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarificationDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'objectId': json['objectId'] == null ? undefined : json['objectId'],
        'objectType': json['objectType'] == null ? undefined : json['objectType'],
        'totaux': json['totaux'] == null ? undefined : TarificationTotauxDtoFromJSON(json['totaux']),
        'garanties': json['garanties'] == null ? undefined : ((json['garanties'] as Array<any>).map(GarantieTarifDtoFromJSON)),
        'frais': json['frais'] == null ? undefined : ((json['frais'] as Array<any>).map(FraisTarifDtoFromJSON)),
        'biens': json['biens'] == null ? undefined : ((json['biens'] as Array<any>).map(BienTarifDtoFromJSON)),
    };
}

export function TarificationDetailsDtoToJSON(json: any): TarificationDetailsDto {
    return TarificationDetailsDtoToJSONTyped(json, false);
}

export function TarificationDetailsDtoToJSONTyped(value?: TarificationDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectId': value['objectId'],
        'objectType': value['objectType'],
        'totaux': TarificationTotauxDtoToJSON(value['totaux']),
        'garanties': value['garanties'] == null ? undefined : ((value['garanties'] as Array<any>).map(GarantieTarifDtoToJSON)),
        'frais': value['frais'] == null ? undefined : ((value['frais'] as Array<any>).map(FraisTarifDtoToJSON)),
        'biens': value['biens'] == null ? undefined : ((value['biens'] as Array<any>).map(BienTarifDtoToJSON)),
    };
}

